import category from './category';
import relationship from './relationship';
import excelUpload from './excelUpload';
import product from './product';

export default { ...category, ...relationship, ...excelUpload, ...product };
